// Components/EditTax.jsx
import React, { useEffect, useState } from "react";
import api from "../../../../../../api/axios";
import Swal from "sweetalert2";

const TAX_TYPES = ["room", "pos"];

const EditTax = ({ open, onClose, tax, onUpdated }) => {
  const [form, setForm] = useState({
    name: "",
    percentage: "",
    type: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && tax) {
      setForm({
        name: tax.name,
        percentage: tax.percentage,
        type: tax.type,
      });
    }
  }, [open, tax]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name.trim()) {
      return Swal.fire({ icon: "warning", title: "Name is required" });
    }

    try {
      setLoading(true);
      await api.put(`/pms/taxes/${tax.id}`, form);

      Swal.fire({
        icon: "success",
        title: "Tax Updated",
        timer: 1200,
        showConfirmButton: false,
      });
      if (onUpdated) onUpdated();
      onClose();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />

      <div className="modal d-block">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Edit Tax</h5>
              <button className="btn-close" onClick={onClose} />
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <label className="form-label">Name</label>
                <input
                  className="form-control mb-2"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />

                <label className="form-label">Percentage (%)</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={form.percentage}
                  onChange={(e) =>
                    setForm({ ...form, percentage: e.target.value })
                  }
                />

                <label className="form-label">Type</label>
                <select
                  className="form-select mb-2"
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                >
                  <option value="">Select Type</option>
                  {TAX_TYPES.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTax;
